<div class="flex min-h-screen min-w-0 flex-col bg-white">
  @if (!hideGlobalHeader()) {
    <app-header />
  }
  <main class="flex min-w-0 flex-1 flex-col overflow-x-clip"
        [style.paddingTop]="hideGlobalHeader() ? '0' : 'calc(4rem + var(--tfr-banner-offset, 0px))'">
    <router-outlet />
  </main>
  <app-cookie-consent />
</div>
